import {
  ADD_PRODUCT,
  REMOVE_PRODUCT,
  HANDLE_ONE_PRODUCT_QUANTITY,
  CART_ERROR,
  LOADING_CART,
  REMOVE_ALL_PRODUCTS,
} from "./types";

export const addProduct = (cart, newProduct) => (dispatch) => {
  dispatch({
    type: LOADING_CART,
  });
  try {
    const myId = newProduct.id;
    const { quantity } = newProduct;
    const updatedCart = cart.filter(({ id }) => id === myId);
    let myValue = {};
    if (updatedCart.length === 1) {
      myValue = updatedCart[0];
      myValue.quantity = myValue.quantity + quantity;
      cart = cart.filter(({ id }) => id !== myId);
      cart.push(myValue);
    } else {
      cart.push(newProduct);
    }

    let string = [];
    cart.map((item) => {
      return string.push(JSON.stringify(item));
    });

    localStorage.setItem("cart", string.toString());

    dispatch({
      type: ADD_PRODUCT,
      payload: cart,
    });
  } catch (error) {
    dispatch({
      type: CART_ERROR,
      payload: error.message,
    });
  }
};
export const removeAllProducts = () => (dispatch) => {
  try {
    dispatch({
      type: REMOVE_ALL_PRODUCTS,
    });
  } catch (error) {
    dispatch({
      type: CART_ERROR,
      payload: error.message,
    });
  }
};
export const removeProduct = (idItem) => (dispatch) => {
  try {
    dispatch({
      type: REMOVE_PRODUCT,
      payload: idItem,
    });
  } catch (error) {
    dispatch({
      type: CART_ERROR,
      payload: error.message,
    });
  }
};

export const handleOneProduct = (cart, id, quantity) => (dispatch) => {
  try {
    const myId = id;
    const updatedCart = cart.filter(({ id }) => id === myId);
    let myValue = {};
    myValue = updatedCart[0];
    myValue.quantity = myValue.quantity + quantity;
    cart = cart.filter(({ id }) => id !== myId);
    cart.push(myValue);

    let string = [];
    cart.map((item) => {
      return string.push(JSON.stringify(item));
    });

    localStorage.setItem("cart", string.toString());
    dispatch({
      type: HANDLE_ONE_PRODUCT_QUANTITY,
      payload: cart,
    });
  } catch (error) {
    dispatch({
      type: CART_ERROR,
      payload: error.message,
    });
  }
};
